import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-13af7e50"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "category-attribute-vod-warp"
};
const _hoisted_2 = {
  class: "table-warp cms-card-block"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "popper__ul"
};
import AddOrEditAttribute from './addOrEditAttribute/index.vue';
import { usePageConfig, useTableOptions } from '@/utils/useComponentConfig';
import { onMounted } from 'vue';
import { useVodLanguages } from '@/utils/cacheData';
import { getTextWidth } from '@/utils';
import { getCurrentTime } from '@/utils/timeFormat';
import { debounce } from '@/utils/tools';
import { getVodGenresListApi } from '@/api/vodNew';
const __default__ = {
  name: 'VodCategoryAttribute'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const addOrEditAttribute = reactive({
      visible: false
    });
    const searchConfig = reactive({
      formList: [{
        label: '分类属性名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入分类属性名称',
        maxlength: 50
      }],
      formData: {
        name: ''
      },
      handleSearch: () => {
        tableConfig.paginationConfig.page = 1;
        getData();
      },
      handleReset: () => {
        tableConfig.paginationConfig.page = 1;
        getData();
      }
    });
    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      // isShowHeader: false,
      options: useTableOptions(),
      listName: '点播分类属性',
      headerButtonsList: [// {
        //   label: '新增',
        //   style: {
        //     'min-width': '120px'
        //   },
        //   func: () => {
        //     addOrEditAttribute.visible = true
        //   }
        // }
      ],
      columnList: [{
        label: '序号',
        prop: 'no',
        width: 100
      }, {
        label: '分类属性名称',
        prop: 'name',
        width: 230,
        sortable: 'custom'
      }, {
        label: '语言',
        prop: 'languageList',
        cellSlot: true,
        showOverflowTooltip: false
      }, {
        label: '创建时间',
        prop: 'createTime',
        sortable: 'custom',
        width: 200,
        formatter: val => {
          return val && getCurrentTime(val);
        }
      } // {
      //   label: '操作',
      //   prop: '',
      //   widgetType: 'buttons',
      //   buttonsList: [
      //     {
      //       label: '修改',
      //       func: (row: any) => {
      //       }
      //     },
      //     {
      //       label: '删除',
      //       func: (row: any) => {
      //       }
      //     },
      //   ]
      // }
      ]
    });
    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      tableConfig.options.loading = true;

      try {
        const res = await useVodLanguages();
        languageOptions.value = res; // console.log('languageOptions', languageOptions.value);
      } catch (error) {}

      getData();
    };

    const getData = async () => {
      tableConfig.options.loading ? '' : tableConfig.options.loading = true;
      const {
        page,
        limit
      } = tableConfig.paginationConfig;

      try {
        const res = await getVodGenresListApi({ ...searchConfig.formData,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...sortParams
        });

        if (res.code == '0') {
          tableConfig.data = res.data.map((item, index) => {
            let languageList = [];

            if (item.texts && item.texts.length) {
              item.texts.forEach(item => {
                let findItem = languageOptions.value.find(f => f.code == item.language);
                if (findItem) languageList.push(`${findItem.name}: ${item.text}`);
              });
            }

            return { ...item,
              no: (page - 1) * limit + index + 1,
              languageList
            };
          }); // console.log('tableConfig.data', tableConfig.data);

          tableConfig.paginationConfig.total = res.total;
        }
      } catch (error) {}

      tableConfig.options.loading = false;
    }; // 内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth < width ? false : true;
    };

    const sortParams = reactive({
      sortType: '',
      sortField: ''
    }); // 表格排序

    const handleSortChange = debounce(async params => {
      // console.log(params);
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        sortParams.sortType = sortType;
        sortParams.sortField = params.prop;
        getData();
      } else {
        sortParams.sortType = '';
        sortParams.sortField = '';
        getData();
      }
    }, 200);
    onMounted(async () => {
      getAllLanguages();
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      return _openBlock(), _createElementBlock(_Fragment, null, [!addOrEditAttribute.visible ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.handleSearch,
        onReset: searchConfig.handleReset
      }, null, 8, ["form-list", "form-data", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_common_table, {
        "option-column-list": tableConfig.columnList,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        onSortChange: _unref(handleSortChange),
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.options,
        render: getData
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property == 'languageList' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_tooltip, {
            disabled: tipDisabled.value,
            enterable: "",
            placement: "top",
            effect: "light",
            "popper-class": "cms--popper"
          }, {
            content: _withCtx(() => [_createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.languageList, item => {
              return _openBlock(), _createElementBlock("li", null, _toDisplayString(item), 1);
            }), 256))])]),
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "white-space": "nowrap",
                "overflow": "hidden",
                "text-overflow": "ellipsis"
              },
              onMouseover: showTextTip
            }, _toDisplayString(scope.row.languageList.join(', ')), 33)]),
            _: 2
          }, 1032, ["disabled"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "onSortChange", "pagination-config", "options"])])])) : _createCommentVNode("", true), addOrEditAttribute.visible ? (_openBlock(), _createBlock(AddOrEditAttribute, {
        key: 1,
        returnBackFn: () => addOrEditAttribute.visible = false
      }, null, 8, ["returnBackFn"])) : _createCommentVNode("", true)], 64);
    };
  }

});